import type { IconLibProps } from '~/components/tools/icon.vue'
import StringMethods from '~/utils/character'

type valuesContext = {
	text: string | number | boolean
	ui?: string
}
export type PricingContext = {
	[product_category: string]: {
		name: valuesContext
		description?: valuesContext
		price?: valuesContext
		tag: valuesContext
		benefit_highlight: valuesContext[]
		card_icon?: IconLibProps | null
		actions: valuesContext
	}[]
}

export const usePricingList = () => {
	const { toLower } = StringMethods()
	const pricingCategories = computed(() => {
		// Sort product to start from health
		const categories = Object.keys(useProductsStore().getProductsByCategory ?? {}).sort((a, b) => {
			return a.startsWith('h') ? -1 : 1
		})
		return categories.map(i => ({ name: i, key: toLower(i) }))
	})
	return { pricingCategories }
}
